import { render, staticRenderFns } from "./SupplierModal.vue?vue&type=template&id=3e4cea9e"
import script from "./SupplierModal.vue?vue&type=script&lang=js"
export * from "./SupplierModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports